export enum Title {
  MRS = '0001',
  MR = '0002',
  COMPANY = '0003',
  MR_AND_MRS = '0004',
  NONE = '0005',
}
